import {
  LandingIconsTitle,
  LandingIconsTitleProps
} from '../../../../components/_external-pages/landing';

/*

  'static/logo/Asociacion-Fintech.svg',
  'static/logo/Best-Credit.svg',
  'static/logo/CANACO.svg',
  'static/logo/Cibergestion.svg',
  'static/logo/Circulo de credito.svg',
  'static/logo/CNBV.svg',
  'static/logo/conducef.svg',
  'static/logo/Creditaria.svg',
  'static/logo/Easyhomes.svg',
  'static/logo/Infinance.svg',
  'static/logo/KEO-Asesores.svg',
  'static/logo/Loanco.svg',
  'static/logo/Salud-patrimonial.svg',
  'static/logo/SOC.svg',
  'static/logo/Solidez-hipotecaria.svg',
  'static/logo/TOI.svg'

* */

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const icons = [
  'static/logo/conducef.svg',
  'static/logo/CNBV.svg',
  'static/logo/ASOFOM.svg',
  'static/logo/Afico.svg',
  'static/logo/Asociacion-Fintech.svg',
  'static/logo/Circulo de credito.svg',
  'static/logo/Cibergestion.svg',
  'static/logo/CANACO.svg',
  'static/logo/Creditaria.svg',
  'static/logo/SOC.svg'
];

const title = 'Unidos generamos mayor confianza';

const props: LandingIconsTitleProps = {
  title,
  icons: []
};

export const HomeAlianzas = () => {
  return <LandingIconsTitle {...props} />;
};
